import React from 'react';

// Subtle navy/gold notice for tools that are still being finished.
export default function UnderConstructionBanner({ text = 'This tool is still being built. Numbers and features may change.' }) {
  return (
    <div role="note" style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#F7F3E6', border: '1px solid #D4AF37', borderLeft: '4px solid #1B2A4A', color: '#1B2A4A', borderRadius: 6, padding: '10px 14px', margin: '0 0 16px', fontSize: 13 }}>
      <span aria-hidden="true" style={{ fontSize: 16 }}>🚧</span>
      <span><strong>Under construction.</strong> {text}</span>
    </div>
  );
}
